module.exports = __webpack_public_path__ + "static/media/c38.e6029ab6.png";